<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <tracking-progress :transDataSet="transDate"></tracking-progress>
        <div class="area_wrap wholeWrap">
          <div class="tab_wrap coming">
            <ul class="tw_item tabs">
              <li
                v-for="tab in tabs"
                :key="tab.tabName"
                :class="{ active: tab === selectedTab }"
                @click="onClickTab(tab)"
              >
                {{ tab.tabName }}
              </li>
            </ul>
            <div v-if="selectedTab === tabs[0]">
              <div class="label_wrap">
                <div class="lw_item_wrap" @change="etcValue">
                  <div
                    class="lw_item"
                    v-for="(c, i) in getComingList"
                    :key="i + 'A'"
                  >
                    <input
                      type="radio"
                      :id="c.id"
                      :value="c.id"
                      :name="c.content"
                      v-model="form.comingReasonCode.value"
                      @click="getReason(i)"
                    />
                    <label :for="c.id" class="type">
                      <h3>{{ c.content }}</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input
                      type="radio"
                      id="etcFirst"
                      class="etcRadio first"
                      :value="form.hiddenValuePre"
                      @click="choiceEtcReason()"
                      v-model="form.comingReasonCode.value"
                    />
                    <label for="etcFirst" class="type">
                      <h3>기타 수술</h3>
                    </label>
                  </div>
                </div>
                <div class="lw_etc pre">
                  <div class="etcInputHeader">
                    <p>기타 수술사유</p>
                    <span
                      class="warn"
                      v-text="form.etcReason.errorTxt"
                      v-if="form.etcReason.hasError"
                    ></span>
                  </div>
                  <label class="reason">
                    <input
                      type="text"
                      class="etc_input"
                      @keyup="blurEtcReason()"
                      placeholder="기타 수술사유를 입력해주세요."
                      ref="etcReason"
                      v-model="form.etcReason.value"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="label_wrap">
                <div class="lw_item_wrap" @change="etcValue2">
                  <div
                    class="lw_item"
                    v-for="(c, i) in getComingList"
                    :key="i + 'B'"
                  >
                    <input
                      type="radio"
                      :id="c.id + 100"
                      :value="c.id"
                      v-model="form.comingReasonCode.value"
                      @click="getReason(i)"
                    />
                    <label :for="c.id + 100" class="type">
                      <h3>{{ c.content }}</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input
                      type="radio"
                      id="etcReason"
                      class="etcRadio last"
                      @click="choiceEtcReason()"
                      v-model="form.comingReasonCode.value"
                      :value="form.hiddenValuePre"
                    />
                    <label for="etcReason" class="type">
                      <h3>기타 검진/검사</h3>
                    </label>
                  </div>
                  <div class="lw_item">
                    <input
                      type="radio"
                      id="etcLast"
                      class="etcRadio last2"
                      @click="choiceEtc()"
                      v-model="form.comingReasonCode.value"
                      :value="form.hiddenValue"
                    />
                    <label for="etcLast" class="type">
                      <h3>기타 사유</h3>
                    </label>
                  </div>
                </div>
                <div class="lw_etc pre">
                  <div class="etcInputHeader">
                    <p>기타 검진/검사</p>
                    <span
                      class="warn"
                      v-text="form.etcReason.errorTxt"
                      v-if="form.etcReason.hasError"
                    ></span>
                  </div>
                  <label class="reason">
                    <input
                      type="text"
                      class="etc_input"
                      @keyup="blurEtcReason()"
                      placeholder="기타 검진/검사를 입력해주세요."
                      ref="etcReason"
                      v-model="form.etcReason.value"
                    />
                  </label>
                </div>
                <div class="lw_etc last">
                  <div class="etcInputHeader">
                    <p>기타 사유</p>
                    <span
                      class="warn"
                      v-text="form.etc.errorTxt"
                      v-if="form.etc.hasError"
                    ></span>
                  </div>
                  <label class="reason">
                    <input
                      type="text"
                      class="etc_input"
                      @keyup="blurEtc()"
                      placeholder="기타 사유를 입력해주세요."
                      ref="etc"
                      v-model="form.etc.value"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="pdSide-22" v-if="firstVisit">
            <div class="title_wrap">
              <h3>방문 경로 선택</h3>
            </div>
            <div class="check_wrap">
              <div class="cw_item" v-for="(v, i) in getVisitList" :key="i">
                <input
                  type="checkbox"
                  :value="v.id"
                  :id="v.id * 100"
                  v-model="form.visitPathCode.value"
                />
                <label :for="v.id * 100">
                  <span class="cw_checkImg"></span>
                  <h3>{{ v.content }}</h3>
                </label>
              </div>
            </div>
          </div>
          <div class="btnWrap visible">
            <button type="button" @click="nextDone()">확인</button>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import TrackingProgress from '../../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '내원사유',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/reservation/explain'
      },
      tabs: [
        { tabName: '수술/시술 상담', code: 'surgery' },
        { tabName: '검진/검사/기타', code: 'checkup' }
      ],
      comingList: [],
      selectedTab: '',
      check: false,
      form: {
        category: {
          value: ''
        },
        comingReasonCategory: {
          value: ''
        },
        comingReasonCode: {
          value: ''
        },
        content: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        visitPathCode: {
          value: [],
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        etc: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '기타 수술사유를 입력해주세요.'
        },
        etcReason: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '기타 사유를 입력해주세요.'
        },
        isEtc: false,
        isEtcReason: false,
        hiddenValuePre: 98,
        hiddenValue: 99
      },
      setCount: false,
      firstVisit: false
    }
  },
  computed: {
    ...mapGetters([
      'getComingList',
      'getComing',
      'getVisitList',
      'GET_RESERVATION_INIT_MESSAGE',
      'GET_RESERVATION_CHECK',
      'GET_RESV_CODE'
    ]),
    ...mapState(['checkPopup'])
  },
  methods: {
    ...mapMutations(['SET_POPUP', 'SET_COMING']),
    ...mapActions(['COMING_LIST', 'VISIT_LIST', 'CHECK_RESERVATION']),
    initEtcValue () {
      this.form.etc.value = ''
      this.form.etcReason.value = ''
    },
    initEtcValueChild () {
      this.form.etc.value = ''
      this.form.etcReason.value = ''
      this.form.isEtc = false
      this.form.isEtcReason = false
    },
    choiceEtc () {
      this.initEtcValue()
      this.form.content.value = ''
      this.form.isEtc = true
      this.form.isEtcReason = false
    },
    choiceEtcReason () {
      this.form.content.value = ''
      this.initEtcValue()
      this.form.isEtcReason = true
      this.form.isEtc = false
    },
    getReason (id) {
      this.form.content.value = this.getComingList[id].content
      console.log('정보', this.getComingList[id])
      console.log('고른 값은?', this.form.content.value)
      this.initEtcValueChild()
    },
    blurEtc () {
      this.form.etc.flag = false
      this.checkEtc()
    },
    blurEtcReason () {
      this.form.etcReason.flag = false
      this.checkEtcReason()
    },
    checkEtc () {
      if (this.form.etc.flag) return true
      const etcInput = document.querySelector('.lw_etc.last')
      const etc = this.form.etc.value.trim()
      if (etcInput.style.display === 'block') {
        this.$refs.etc.focus()
        if (etc === '') {
          console.log('비어서 빈값에 진입함', etcInput)
          this.form.etc.hasError = true
          this.form.etc.flag = false
          this.form.etc.errorTxt = '기타 사유를 입력해주세요.'
          return false
        }
      }
      if (etcInput.style.display === 'none') {
        this.form.etc.hasError = false
        this.form.etc.flag = true
        this.form.etc.errorTxt = ''
      }
      this.form.etc.flag = true
      this.form.etc.hasError = false
      this.form.etc.errorTxt = ''
      return true
    },
    checkEtcReason () {
      if (this.form.etcReason.flag) return true
      const etcInput = document.querySelector('.lw_etc.pre')
      const etcReason = this.form.etcReason.value.trim()
      if (etcInput.style.display === 'block') {
        this.$refs.etcReason.focus()
        if (etcReason === '') {
          this.form.etcReason.hasError = true
          this.form.etcReason.flag = false
          this.form.etcReason.errorTxt = '기타 수술사유를 입력해주세요.'
          return false
        }
      }
      if (etcInput.style.display === 'none') {
        this.form.etcReason.hasError = false
        this.form.etcReason.flag = true
        this.form.etcReason.errorTxt = ''
      }
      this.form.etcReason.flag = true
      this.form.etcReason.hasError = false
      this.form.etcReason.errorTxt = ''
      return true
    },
    etcValue () {
      const etc1 = document.querySelector('.etcRadio.first')
      const input = etc1.closest('.label_wrap').childNodes[1]
      console.log('input', input) // etc
      console.log('etc1.value', etc1.value)
      console.log(
        'this.form.comingReasonCode.value',
        this.form.comingReasonCode.value
      )
      if (this.form.hiddenValuePre === this.form.comingReasonCode.value) {
        input.style.display = 'block'
        this.$refs.etcReason.focus()
      }
      if (this.form.hiddenValuePre !== this.form.comingReasonCode.value) {
        input.style.display = 'none'
      }
    },
    etcValue2 () {
      const etc2 = document.querySelector('.etcRadio')
      const inputPre = etc2.closest('.label_wrap').childNodes[1]
      const input = etc2.closest('.label_wrap').childNodes[2]
      console.log('inputPre', inputPre)
      console.log('input', input)
      console.log('etc2.value', etc2.value)
      if (this.form.hiddenValuePre === this.form.comingReasonCode.value) {
        inputPre.style.display = 'block'
        input.style.display = 'none'
        this.$refs.etc.focus()
      } else if (
        this.form.hiddenValuePre !== this.form.comingReasonCode.value &&
        this.form.comingReasonCode.value !== this.form.hiddenValue
      ) {
        inputPre.style.display = 'none'
        input.style.display = 'none'
      } else if (this.form.hiddenValue === this.form.comingReasonCode.value) {
        input.style.display = 'block'
        inputPre.style.display = 'none'
        this.$refs.etcReason.focus()
      } else if (
        this.form.hiddenValue !== this.form.comingReasonCode.value &&
        this.form.comingReasonCode.value !== this.form.hiddenValuePre
      ) {
        inputPre.style.display = 'none'
        input.style.display = 'none'
      }
    },
    initialize () {
      this.form.comingReasonCode.value = ''
      this.form.content.value = ''
      this.form.isEtc = false
      document
        .querySelector('.etcRadio')
        .closest('.label_wrap').childNodes[1].style.display = 'none'
      this.initEtcValue()
    },
    onClickTab (tab) {
      this.selectedTab = tab
      this.initialize()
      this.fetchData()
    },
    nextDone () {
      const etc = this.form.etc.value.trim()
      const etcReason = this.form.etcReason.value.trim()
      const etcContents =
        this.form.etc.value.trim() + this.form.etcReason.value.trim()
      if (this.form.isEtcReason) {
        console.log('현재의 값은? ', etcReason)
        if (etcReason === '') {
          this.SET_POPUP(true)
          this.popupSet.content = '기타 내원사유를 입력해주세요.'
          this.form.etcReason.flag = false
          this.form.etcReason.hasError = true
          return false
        }
        this.$refs.etcReason.focus()
      }
      if (this.form.isEtc) {
        console.log('현재의 값은 etc? ', etc.trim())
        if (etc === '') {
          this.SET_POPUP(true)
          this.popupSet.content = '기타 사유를 입력해주세요.'
          this.form.etc.flag = false
          this.form.etc.hasError = true
          return false
        }
      }
      if (this.form.comingReasonCode.value === '') {
        this.SET_POPUP(true)
        this.popupSet.content = '내원사유를 선택해주세요.'
        return false
      }
      if (this.firstVisit) {
        if (this.form.visitPathCode.value.length <= 0) {
          this.SET_POPUP(true)
          this.popupSet.content = '방문경로를 선택해주세요.'
          return false
        }
      }
      const coming = {
        comingReasonCategory: this.selectedTab.code,
        comingReasonCode: this.form.comingReasonCode.value,
        visitPathCode: this.form.visitPathCode.value || '',
        etc: this.form.isEtc,
        etcReason: this.form.isEtcReason,
        etcContents: etcContents,
        content: this.form.content.value
      }
      this.$store.commit('SET_COMING', coming)
      this.$router.push('/reservation/selectDoctor')
    },
    async fetchData () {
      try {
        const category = this.selectedTab.code
        await this.COMING_LIST(category)
        // 초진인 환자 내원시
        if (this.firstVisit) {
          this.visitListAct()
        }
        console.log('비짓리스트는 있습니까?', this.getVisitList)
      } catch (error) {
        console.log('error :', error);
        console.log('내원사유 리스트 API 에서 에러가 남')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async visitListAct () {
      try {
        await this.VISIT_LIST()
      } catch (error) {
        console.log('error :', error);
        console.log('내원사유 API실행 중 에러가 났습니다.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async pressReservation () {
      let getCode
      if (this.GET_RESV_CODE.length >= 1) {
        getCode = Number(this.GET_RESV_CODE)
      } else {
        getCode = 0
      }
      console.log('가져온 파람', getCode)
      try {
        await this.CHECK_RESERVATION().then(() => {
          if (this.GET_RESERVATION_CHECK.length !== undefined && this.GET_RESERVATION_CHECK[0] !== undefined) {
            if (this.GET_RESERVATION_CHECK[0].flag === 'first') {
              this.firstVisit = true
            } else if (this.GET_RESERVATION_CHECK[0].flag === 'future') {
              this.firstVisit = false
            } else {
              this.firstVisit = false
            }
          } else {
            if (this.GET_RESERVATION_CHECK.flag !== undefined) {
              if (this.GET_RESERVATION_CHECK.flag === 'first') {
                this.firstVisit = true
              } else if (this.GET_RESERVATION_CHECK.flag === 'future') {
                this.firstVisit = false
              } else {
                this.firstVisit = false
              }
            } else {
              this.firstVisit = false
            }
          }
        })
      } catch (error) {
        console.log('error :', error);
        console.log('예약상태 확인API 에서 에러가남')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async dataTransModule () {
      console.log('사전 정보 찾기', this.getComing.content)
      console.log('사전 정보 찾기', this.getComing.content === '')
      this.selectedTab = this.tabs[0]
      await this.pressReservation()
      await this.fetchData()
    },
    callPrev () {
      if (this.setCount) {
        if (this.firstVisit) {
          this.$router.push('/reservation/explain')
        } else {
          if (
            sessionStorage.getItem('pathFromLoadUnAuth') ===
            '/telReservation_step1'
          ) {
            this.$router.push('/')
          } else {
            this.$router.push('/reservation/reCare')
          }
        }
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  mounted () {},
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.dataTransModule()
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
